var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.158 19.961a15.652 15.652 0 008.47 2.483c10.165 0 15.724-8.421 15.724-15.724 0-.24-.006-.477-.016-.714a11.261 11.261 0 002.757-2.861c-1.009.447-2.078.74-3.174.87a5.545 5.545 0 002.43-3.057 11.067 11.067 0 01-3.509 1.34 5.532 5.532 0 00-9.417 5.04 15.687 15.687 0 01-11.39-5.773 5.53 5.53 0 001.71 7.377 5.49 5.49 0 01-2.503-.69l-.001.07a5.529 5.529 0 004.434 5.417 5.515 5.515 0 01-2.496.095 5.532 5.532 0 005.163 3.838 11.1 11.1 0 01-6.864 2.366c-.441 0-.881-.026-1.318-.077",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "1462498df25cfb3e8a88ecbc31c6fd77.svg";
export { SvgTwitter as ReactComponent };